import { cn } from '@ds';
import { ReactElement } from 'react';
import { MdDoneAll } from 'react-icons/md';

type ConfirmationUserCardProps = {
  icon: ReactElement;
  text: string;
  checked?: boolean;
};

export const ConfirmationUserCard = ({ icon, text, checked }: ConfirmationUserCardProps) => {
  const textColorClass = checked ? 'text-base-5' : 'text-base-30';

  return (
    <div className={cn('flex flex-col flex-1 gap-2 bg-base-90 rounded-xl p-1', textColorClass)}>
      <div className="flex flex-1 justify-between">
        <div className={textColorClass}>{icon}</div>
        <div>{checked && <MdDoneAll className="text-success-30" />}</div>
      </div>
      <div className="text-xs-m">{text}</div>
    </div>
  );
};
